<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol>
        <CCard>
          <CCardBody>
            <CForm  @submit.prevent="registerAccount">
              <h3>Đăng ký tài khoản</h3>
              <!-- <p class="text-muted">Thông tin tài khoản</p> -->
              <CInput
                placeholder="Tên tài khoản"
                autocomplete="username"
                v-model="account.username" required
              >
                <template #prepend-content><CIcon name="cil-user"/></template>
              </CInput>
              <CInput
                placeholder="Tên hiển thị"
                autocomplete="displayname"
                v-model="account.display">
                <template #prepend-content><CIcon name="cil-screen-desktop"/></template>
              </CInput>
              <CInput
                placeholder="Email"
                autocomplete="email"
                prepend="@"
                v-model="account.email" required
              />
              <CInput
                type="date"
                id="date-input"
                placeholder="'Ngày sinh'"
                v-model="account.birthday" required
              >
                <template #prepend-content><CIcon name="cil-calendar"/></template>
              </CInput>

              <CButton color="info" type="submit" shape="pill" class="mr-1" style="width: 150px"
              >Đăng ký</CButton>
              <CButton color="secondary" shape="pill" class="mr-1" style="width: 150px" @click="goBack"
              >Quay lại</CButton>

            </CForm>
            <!-- <CAlert style="margin-top: 15px"
              v-if="alertVisible"
              :color="alertType"
              dismissible
              @dismiss="alertVisible = false"
            >
              {{ alertMessage }}
            </CAlert> -->
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  data() {
    return {
      account: {
        username: '',
        display: '',
        email: '',
        birthday: '',
        password: '',
        repeatPassword: '',
      },
      alertVisible: false,
      alertType: "success",
      alertMessage: ''
    }
  },
  methods: {
    registerAccount() {
      this.$request.post('/user/register',
        this.account).then(res => {
        if(res.data.status === 'success') {
          this.$swal.fire({
            icon: "success",
            title: "Đăng ký tài khoản",
            html: "Đăng ký tài khoản: " + this.account.username + " thành công <br>" + res.data.message,
          });
          this.$router.go(-1);
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Đăng ký tài khoản",
            html: "Đăng ký tài khoản: " + this.account.username +
              " thất bại!<br>lỗi: " + res.data.status,
          });
        }
      })
    },
    validate() {
      return this.account.password === this.account.repeatPassword;
    },
    showAlert(show, message) {
      this.alertVisible = show;
      this.alertMessage = message;
    },
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>
